// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppButton-module__whatsappButton___KajP8"};